
<template>
    <v-app id="overviewFeratel">
      <v-main>
      <v-container fluid>  
      <v-card>
        <v-card-title>Overview Feratel accommodations
        </v-card-title>
        <v-card-text color="success">
            <v-chip>{{ aantalHuizen }} Accommodations</v-chip>  &nbsp;
            <v-chip color="success">{{ aantalHuizenFeratel }} With working connection</v-chip>  &nbsp;
            <v-chip color="warning">{{ aantalHuizenFeratelGuestcard }} With Manual send Guestcard</v-chip>
        </v-card-text>
        <v-row dense no-gutters>
            <v-col cols="2" class="mx-2">
                <v-text-field v-model="huis_code" label="Acco ID" hint="Search values beginning with..." @keyup.enter="getAccos" class="pr-4"></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-select v-model="plts_nr" :items="plts_nrKeuzesFiltered" item-value="plts_nr" item-text="plts_naam"
                  label="City" clearable>
                  <template v-slot:prepend-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-text-field v-model="searchCityInput" placeholder="Search"></v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                </v-select>
              </v-col>
            <v-col cols="2" class="mx-2">
                <v-select v-model="huisServiceTeam" label="Feratel Service team" :items="serviceTeamChoices" multiple></v-select>
            </v-col>
            <v-col cols="2" class="mx-2">
                <v-select v-model="huisGuestCard" label="Guestcard" :items="guestCardChoices2" item-text="oms" item-value="value" multiple></v-select>
            </v-col>
            <v-col cols="1">
                    <v-btn class="primary ma-0" small @click="getAccos" :loading="loading">Search</v-btn>
                </v-col>
            <v-data-table 
            :items="items" 
            :search="search"
            :fixed-header=true
            :headers="getHeaders()" 
            :disable-pagination=true 
            :loading="loading"
            no-data-text="No accommodations to display" 
            :hide-default-footer="true" 
        >
            <template v-slot:item="props">
                <tr>
                <td class="image-alignment">
                    <div class="image-borders" style="cursor: pointer;">
                        <v-img :src="props.item.photo" width="125px" height="100px"  @click="$router.open('/huis/onHuis/' + props.item.huis_encrid)"></v-img>
                    </div>
                    <slot name="parkbutton" :param="props.item.huis_encrid" :acco="props.item.huis_code" :park="props.item.park_naam" />
                </td>
                <td @click="$router.open('/huis/onHuis/' + props.item.huis_encrid)" class="td-markup">
                    <div><a> {{ props.item.huis_code }} </a></div>
                    <div class="default-cursor"><span> {{ props.item.bedr_code }} </span><span class="ml-2 mr-2">-</span><span> {{ props.item.hstptaal_oms }} </span></div>
                    <div class="default-cursor">{{ props.item.cttptaal_oms }} </div>
                </td>
                <td class="td-markup default-cursor">
                    <div style="display: flex; flex-direction: row; align-items:center;">
                        <div class="mt-1">{{ props.item.pricing_system }}</div>
                        <div v-if="props.item.hasPriorityPrice"><v-avatar :size="18" style="border: solid 2px red; margin-left: 6px;"><v-icon color="red" x-small>mdi-parking</v-icon></v-avatar></div>
                    </div>
                </td>
                <td class="td-markup">
                    <div class="headline text-center default-cursor"> {{ props.item.stat_code }} 
                        <span v-if="props.item.hserNumberOfErrors !== ''"><v-avatar size="21" class="mb-1 mr-1 acco-error"> {{ props.item.hserNumberOfErrors }} </v-avatar></span>
                        <span v-if="props.item.hserNumberOfWarnings !== ''"><v-avatar size="21" class="mb-1 acco-warning"> {{ props.item.hserNumberOfWarnings }} </v-avatar></span>
                    </div>
                    <div class="text-center default-cursor"><v-icon>mdi-account</v-icon> {{ props.item.huis_aantpers_max }}</div>
                </td> 
                <td>
                    <table>
                        <tr><td>Oestat</td><td>{{ props.item.huis_feratel_oestat }}</td></tr>
                        <tr><td>Betrieb nr</td><td>{{ props.item.huis_feratel_betriebnr }}</td></tr>
                        <tr><td>Login name</td><td>{{ props.item.huis_feratel_loginname }}</td></tr>
                        <tr><td>Host booking</td>
                            <td><v-icon v-if="props.item.huis_feratel_hostbooking" left color="success" class="ma-1" v-bind="attrs" v-on="on">
                                    mdi-check-circle-outline
                                </v-icon>
                                <v-icon v-else class="ma-1">
                                    mdi-close-circle-outline
                                </v-icon></td>
                        </tr>
                        <tr><td>Connection</td>
                            <td>
                                <v-tooltip  v-if="props.item.huis_feratel_connection_check !== '' && props.item.huis_feratel_open_blocks !== ''" color="success" bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon left color="success" class="ma-1" v-bind="attrs" v-on="on">
                                            mdi-check-circle-outline
                                        </v-icon>
                                    </template>
                                    <span>Working connection since {{ props.item.huis_feratel_connection_check }}. Open blocks since {{ props.item.huis_feratel_open_blocks }}</span>
                                </v-tooltip>
                                <v-tooltip v-if="props.item.huis_feratel_open_blocks == '' && props.item.huis_feratel_connection_check !== ''" color="warning" bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon left color="warning" class="ma-1" v-bind="attrs" v-on="on">
                                            mdi-alert-circle-outline
                                        </v-icon>
                                    </template>
                                    <span>Connection working, no open block (use button to open)</span>
                                </v-tooltip>
                                <v-icon v-if="props.item.huis_feratel_connection_check === ''" class="ma-1">
                                    mdi-close-circle-outline
                                </v-icon>
                            </td>
                        </tr>
                        
                    </table>
                </td>                
                <td class="td-markup default-cursor">
                    <div>{{ props.item.huis_plaats }}</div>
                    <div>{{ props.item.huis_naam }}</div>
                    <div v-if="props.item.connector!==''"> {{ props.item.connector }} - {{ props.item.park_naam }} </div>
                    <div v-if="props.item.connector!==''" class="tiny"> ({{ props.item.toname }}) </div>
                    <div v-else></div>
                </td>
                <td class="td-markup default-cursor">
                    <div v-for="contact in props.item.contacts" v-bind:key="contact.eign_code">
                        <td><span class="mr-3" @click="$router.open('/eign/onEign/' + contact.eign_encrid)"><a>{{ contact.eign_code }}</a></span><span>{{ contact.eign_naam }}</span><span class="ml-2 mr-2">-</span><span>{{ contact.hsct_rol }}</span></td>
                    </div>
                </td>
                <td class="td-markup default-cursor">
                    <div v-for="regel in props.item.planning" v-bind:key="regel.planCode">
                        <td>{{ regel.planCode }}</td>
                    </div>
                </td>
                <td class="td-markup default-cursor">
                    <div v-for="regel in props.item.planning" v-bind:key="regel.planCode">
                        <td>{{ regel.planToCode }}</td>
                    </div>
                </td>
                <td class="td-markup default-cursor">
                    <div> {{ props.item.huis_feratel_service }} </div>
                </td>
                <td class="td-markup default-cursor">
                    <div> {{ props.item.huis_feratel_guestcard }} </div>
                </td>                         
                </tr> 
            </template>

        </v-data-table>
        </v-row>
      </v-card>  
      </v-container>
      </v-main>
      <navBar title="Ares - Various" :home="true" type="various" />    
    </v-app>
  </template>
  
  
  <script>
      import navBar from "@/components/ui/navbars/navbar.vue";
      export default {
          components: {
              navBar,
          },
          data() {
              return {
                overviewFeratel: [],
                search: '',
                loading: false,
                headers: [
                    { text: 'Id', value: 'huov_code' },
                    { text: 'Status', value: 'hust_code' },
                    { text: 'Accommodation', value: 'huis_code' },
                    { text: 'Booking', value: 'huov_dt' },
                    { text: 'Persons', value: 'huov_pers' },
                    { text: 'Arrival', value: 'huov_van_dat' },
                    { text: 'Departure', value: 'huov_tm_dat' },
                    { text: 'Guest', value: 'klnt_naam' },
                    { text: 'Sales partner', value: 'inpt_naam' },
                    { text: 'Travel Party', value: 'huov_travelparty_complete'},
                    { text: 'Feratel Mblattnr', value: 'huov_feratel_mblattnr'},
                    { text: 'Feratel Guid', value: 'huov_feratel_guid'},
                    { text: 'Feratel Service team', value: 'huov_feratel_service'},
                    { text: 'Days before arrival', value: 'huov_days_before_arrival'},
                    { text: '', sortable: false, width: '7%' }
                ],
                items:[],
                aantalHuizen: '',
                aantalHuizenFeratel: '',
                aantalHuizenFeratelGuestcard: '',
                huovVanDatVan: '',
                huovVanDatTm: '',
                serviceTeamChoices: [],
                guestCardChoices: [],
                guestCardChoices2: [],
                huisServiceTeam: '',
                huisGuestCard: '',
                huis_code: '',
                plts_nrKeuzes: [],
                plts_nr: '',
                searchCityInput: '',
                huovVanDatVanmenu: false,
                huovVanDatTmmenu: false,
              }  
          },
          computed: {
    plts_nrKeuzesFiltered() {
      let cities = this.plts_nrKeuzes
      if (this.searchCityInput) {
        cities = cities.filter(x => {
          return x.plts_naam.toLowerCase().indexOf(this.searchCityInput.toLowerCase()) > -1;
        })
      }
      return cities
    }
  },
  created() {
    this.$axios
      .post("ares/json/ares/huis/getSearchHuisPlts.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getSearchHuisParam"
        },
        getSearchHuisParam: {}
      })
      .then(res => {
        if (res.data.error) {
          console.log(res.data.error);
        } else {
          this.plts_nrKeuzes = res.data.getSearchHuisParam.plts_nrKeuzes
        }
      });

  },
      mounted() {
                this.loading=true;
                this.$axios
                  .post("ares/json/ares/task/various/huis/overviewFeratelHuis.p", {
                      header: {
                          token: this.$session.get("ARES"),
                          clientSessionId: this.$session.id(),
                          request: "overviewFeratelHuis"
                      },
                      overviewFeratelHuis: {
                        serviceteam: this.huisServiceTeam,
                        guestcard: this.huisGuestCard,
                        huis_code: this.huis_code,
                        plts_nr: this.plts_nr,
                      }
                  })
                  .then(res => {
                      if (res.data.error) {
                          console.log(res.data.error);
                      } else {
                          this.items = res.data.searchHuis;
                          this.aantalHuizen = res.data.aantalHuizen;
                          this.aantalHuizenFeratel = res.data.aantalHuizen_Feratel;
                          this.aantalHuizenFeratelGuestcard = res.data.aantalHuizen_Manualguestcard;
                          this.serviceTeamChoices = res.data.serviceteamChoices;
                          this.guestCardChoices = res.data.guestCardChoices;
                          this.guestCardChoices2 = res.data.guestCardChoices2;
                          this.loading = false;
                        
                      }
                  })
                  .finally(() => {
                      this.loading = false;
                  });
          },
          methods: {
            getAccos() {
                this.loading=true;
                this.$axios
                .post("ares/json/ares/task/various/huis/overviewFeratelHuis.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "overviewFeratelHuis"
                    },
                    overviewFeratelHuis: {
                        serviceteam: this.huisServiceTeam,
                        guestcard: this.huisGuestCard,
                        huis_code: this.huis_code,
                        plts_nr: this.plts_nr,
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        this.loading = false;
                    } else {
                        this.items = res.data.searchHuis;
                        this.aantalHuizen = res.data.aantalHuizen;
                        this.aantalHuizenFeratel = res.data.aantalHuizen_Feratel;
                        this.loading = false;
                    }
                })
            }, 
            getColor(v){
                console.log(v);
                v===1?'warning':'success';
            },
            getHeaders(){
                return [
                    { text: "", sortable: false},
                    { text: "Accommodation", value: 'searchsethuis', hsortable: false},
                    { text: "Pricing", value: 'pricing_system', sortable: false, width: "1%" },
                    { text: "State", value: 'stat_code', align: "center", sortable: false},
                    { text: "Feratel", sortable: false},
                    { text: "Place/name", value: 'searchsetplace', sortable: false},
                    { text: "Contacts", value: 'searchsetcontact', sortable: false},
                    { text: "Planning code(s)", value: 'searchsetplan', sortable: false},
                    { text: "TO code(s)", value: 'searchsettocode', sortable: false},
                    { text: "Feratel Service Team", value: 'feratel_service_team', sortable: false},
                    { text: "Feratel Guest Card", value: 'feratel_guest_card', sortable: false},
                    { text: "", sortable: false , width: "1%"},
                ];
            }
        
         }
      };
  
  </script> 
  